import React, { useEffect, useState } from "react";
// import { useAuthContext } from "../../../hooks/useAuthContext";
// import { projectFirestore } from "../../../firebase/config";
import {
  Table,
  // Pagination,
  Col,
  Row,
  Container
} from "react-bootstrap";
import { PieChart, pieArcLabelClasses } from "@mui/x-charts/PieChart";
import { useLocation } from "react-router-dom";
// import {
//   onSnapshot,
//   collection,
//   query,
//   where,
//   updateDoc,
//   doc,
// } from "firebase/firestore";

// style
// import {
//   utilGetMesas,
//   utilGetCollectionFilter,
//   utilUpdateTables,
//   utilGetDocumentById,
// } from "../../../util/UtilsFirebase";
import "./Filtros.css";

export default function Mesas() {
  const location = useLocation();
  // const { register } = useAuthContext();
  // const [data, setData] = useState([]);
  const [filters, setFilters] = useState([]);
  const [hide, setHide] = useState("");

  const handleChange = (e) => {
    if (e.target.type === "checkbox") {
      setFilters({
        ...filters,
        [e.target.name]: e.target.checked,
      });
    } else {
      setFilters({
        ...filters,
        [e.target.name]: e.target.value,
      });
    }
  };

  const HiddenTable = () => {
    if (hide === "hidden") {
      setHide("");
      let elem = document.getElementById("ex-tblChecador");
      elem.hidden = true;
    } else {
      setHide("hidden");
      let elem = document.getElementById("ex-tblChecador");
      elem.removeAttribute("hidden");
    }
  };

  useEffect(() => {}, []);

  return (
    <div>
      <h1>{location.state.Name}</h1>
      <br />
      <br />
      <Container>
        <Row>
          <Col md={4}>
            <PieChart
              series={[
                {
                  arcLabel: (item) => `${item.value}`,
                  arcLabelMinAngle: 45,
                  highlightScope: { faded: "global", highlighted: "item" },
                  faded: {
                    innerRadius: 30,
                    additionalRadius: -30,
                    color: "gray",
                  },
                  data: [
                    { id: 0, value: 10, label: "series A" },
                    { id: 1, value: 15, label: "series B" },
                    { id: 2, value: 20, label: "series C" },
                  ],
                },
              ]}
              sx={{
                [`& .${pieArcLabelClasses.root}`]: {
                  fill: "white",
                  fontWeight: "bold",
                  fontSize: "40px",
                },
              }}
              width={500}
              height={350}
            />
          </Col>
          <Col md={2}></Col>
          <Col md={2} className="">
            <h4 className="center">Ventas</h4>
            <Row style={{ margin: "unset !important" }}>
              <div className="form-switch lblFiltro">
                <label className="lblFiltro">Mas vendido</label>
                <input
                  className="form-check-input"
                  type="checkbox"
                  checked={filters.configuracion}
                  onChange={handleChange}
                  name="configuracion"
                  id="flexSwitchCheckDefault"
                />
              </div>
            </Row>
            <Row style={{ margin: "unset !important" }}>
              <div className="form-switch">
                <label className="lblFiltro">Menos vendido</label>
                <input
                  className="form-check-input"
                  type="checkbox"
                  checked={filters.checador}
                  onChange={handleChange}
                  name="checador"
                  id="flexSwitchCheckDefault"
                />
              </div>
            </Row>
          </Col>
          <Col md={2} className="">
            <h4 className="center">Agrupacion</h4>
            <Row style={{ margin: "unset !important" }}>
              <div className="form-switch">
                <label className="lblFiltro">Por categoria</label>
                <input
                  className="form-check-input"
                  type="checkbox"
                  checked={filters.personal}
                  onChange={handleChange}
                  name="personal"
                  id="flexSwitchCheckDefault"
                />
              </div>
            </Row>
            <Row style={{ margin: "unset !important" }}>
              <div className="form-switch">
                <label className="lblFiltro">Por producto</label>
                <input
                  className="form-check-input"
                  type="checkbox"
                  checked={filters.meseros}
                  onChange={handleChange}
                  name="meseros"
                  id="flexSwitchCheckDefault"
                />
              </div>
            </Row>
          </Col>
          <Col md={2} className="">
            <h4 className="center">Periodo</h4>
            <Row style={{ margin: "unset !important" }}>
              <div className="form-switch">
                <label className="lblFiltro">Mensual</label>
                <input
                  className="form-check-input"
                  type="checkbox"
                  checked={filters.menu}
                  onChange={handleChange}
                  name="menu"
                  id="flexSwitchCheckDefault"
                />
              </div>
            </Row>
            <Row style={{ margin: "unset !important" }}>
              <div className="form-switch">
                <label className="lblFiltro">Semanal</label>
                <input
                  className="form-check-input"
                  type="checkbox"
                  checked={filters.inventario}
                  onChange={handleChange}
                  name="inventario"
                  id="flexSwitchCheckDefault"
                />
              </div>
            </Row>
            <Row style={{ margin: "unset !important" }}>
              <div className="form-switch">
                <label className="lblFiltro">Diario</label>
                <input
                  className="form-check-input"
                  type="checkbox"
                  checked={filters.resenas}
                  onChange={handleChange}
                  name="resenas"
                  id="flexSwitchCheckDefault"
                />
              </div>
            </Row>
            <Row style={{ margin: "unset !important" }}>
              <div className="form-switch">
                <label className="lblFiltro">Personalizado</label>
                <input
                  className="form-check-input"
                  type="checkbox"
                  checked={filters.galeria}
                  onChange={handleChange}
                  name="galeria"
                  id="flexSwitchCheckDefault"
                />
              </div>
            </Row>
          </Col>
        </Row>
      </Container>
      <Container>
        <Col md={4}>
          <div className="form-switch">
            <label className="lblFiltro">Visualizar datos en tabla</label>
            <input
              className="form-check-input"
              type="checkbox"
              checked={hide}
              onChange={HiddenTable}
              name="hide"
              id="flexSwitchCheckDefault"
            />
          </div>
        </Col>
        <Table striped bordered hover hidden border="2" id="ex-tblChecador">
          <thead>
            <tr>
              <th>Valor</th>
              <th>Etiqueta</th>
            </tr>
          </thead>
          <tbody>
            {/* {getElementsForPage(currentPage).sort().map((val, key) => {
                            return ( */}
            <tr key={""}>
              <td>20</td>
              <td>series A</td>
            </tr>
            <tr key={""}>
              <td>15</td>
              <td>series B</td>
            </tr>
            <tr key={""}>
              <td>10</td>
              <td>series C</td>
            </tr>
            {/* )
                    })} */}
          </tbody>
        </Table>
        {/* <Pagination>
                {Array.from({ length: Math.ceil(dataChec.length / elementsPerPage) }).map(
                    (page, index) => (
                    <Pagination.Item
                        key={index}
                        active={index + 1 === currentPage}
                        className={index + 1 === currentPage ? "btn-paginado" : ""}
                        onClick={() => setCurrentPage(index + 1)}
                    >
                        {index + 1}
                    </Pagination.Item>
                    )
                )}
            </Pagination> */}
      </Container>
    </div>
  );
}